// Import Framework7 Styles
import "framework7/css/bundle";
// Import Icons and App Custom Styles
import "@/css/app.css";
import "@/css/icons.css";

import * as Sentry from "@sentry/react";
// Import Framework7 and React
import Framework7 from "framework7/lite-bundle";
import Framework7React from "framework7-react";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import invariant from "ts-invariant";

// Import App Component (TSX)
import { App } from "./components/App";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
});
Sentry.setTag("env", import.meta.env.MODE);

// Init F7 React Plugin
Framework7.use(Framework7React); // eslint-disable-line react-hooks/rules-of-hooks

// Mount React App
const appEl = document.getElementById("app");
invariant(appEl, "Root element #app not found");
const root = createRoot(appEl);
root.render(createElement(App));
